<template>
  <section class="ctn">
    <header class="header">
      <router-link class="paper-action" to="/servers/new"><heim-icon icon="add"></heim-icon><span>{{ $t('new') }}</span></router-link>
    </header>
    <section class="table">
      <heim-table :data="filteredServers" :columns="['id', 'name', 'enabled']"  cols="8">
        <template slot="colgroup">
          <col class="one">
          <col class="two">
          <col class="three">
          <col class="four">
          <col class="four">
          <col>
          <col>
          <col class="ten">
        </template>
        <template slot="thead" slot-scope="props">
          <th class="collapse"></th>
          <th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('name')">{{ $t('servers') }}<heim-icon :icon="props.sortOrders['name'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="server">{{ $t('providers') }}</th>
          <th class="status sortable" @click="props.sortBy('enabled')">{{ $t('monitoring') }}<heim-icon :icon="props.sortOrders['enabled'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="action edit"></th>
          <th class="action activity"></th>
          <th class="action details"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr :key="'sites-'+index">
            <td>
              <heim-icon-button
                :class="show(item)?'opened':''"
                class="icon-button"
                @click.native="openDetail(item)">
                <heim-icon icon="chevron-right"></heim-icon>
              </heim-icon-button>
            </td>
            <td class="id" data-title="#">{{item.id}}</td>
            <td data-title="Servers">
              <div class="row-ctn">
                <span class="label">{{item.name}}</span>
                <div class="link"><a :href="item.url" target="_blank">{{item.ip}}</a></div>
              </div>
            </td>
            <td class="provider"><router-link :to="{ path: `/providers/${item.Providers.id}`}">{{ item.Providers.name }}</router-link></td>
            <td class="status" data-title="Status">
              <span class="badge" :class="item.enabled?'green':'red'">{{item.enabled? $t('enabled') : $t('disabled')}}</span>
              <span class="chip" :class="item.enabled?'green':'red'"></span>
            </td>
            <td class="edit" data-title="Edit">
              <router-link class="paper-action" :to="{ path: `/servers/${item.id}/edit` }">
                <span>{{ $t('edit') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="activity" data-title="Activity">
              <router-link class="paper-action" :to="{ path: `/servers/${item.id}/details` }">
                <heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="details mobile-link"><router-link class="link"  :to="{ path: `/servers/${item.id}/details`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
          </tr>
          <!-- Do not add `key` here (breaks details) -->
          <!-- eslint-disable-next-line -->
          <transition name="slide-fade" :key="'detail-'+index">
            <tr v-if="show(item)" class="detail" :data-detail="item.id">
              <td class="detail-row" :colspan="cols">
                <div class="detail-container">
                  <div class="row">
                    <div class="item" :class="!item.cpu_alert?'disabled':''">
                      <span class="label">{{ $t('cpuThreshold') }}</span>
                      <div>{{ item.cpu_threshold }}%</div>
                    </div>
                    <div class="item" :class="!item.mem_alert?'disabled':''">
                      <span class="label">{{ $t('memoryThreshold') }}</span>
                      <div>{{ item.mem_threshold }}%</div>
                    </div>
                    <div class="item" :class="!item.drive_alert?'disabled':''">
                      <span class="label">{{ $t('diskThreshold') }}</span>
                      <div>{{ item.drive_threshold }}%</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('beforeNotification') }}</span>
                      <div>{{ item.nb_occurence }} {{ $t("occurences") }}</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('pingInterval') }}</span>
                      <div>{{ item.interval/1000 }}s</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('provider') }}</span>
                      <div>
                        <router-link :to="{ path: `/providers/${item.Providers.id}`}">{{ item.Providers.name }}</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </transition>
        </template>
      </heim-table>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
export default {
  name: "ServersList",
  components: {
    HeimIcon,
    HeimIconButton,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getServers");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.servers,
      val => {
        this.setupServers();
      }
    );
    this.setupServers();

    this.$store.dispatch("setTitle", "Servers");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ servers: state => state.serversState.servers })
  }
};
</script>

<style scoped>
.disabled {
  color: #8b969c;
}

col.one { width: 8%; }
col.two { width: 10%; }
col.three { width: 30%; }
col.four { width: 15%; }
col.five { width: 1%; }
col.six { width: 1%; }
col.seven { width: 1%; }
col.eight { width: 1%; }
col.nine { width: 1%; }
col.ten { width: 1%; }
</style>
